import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const WarningRound = forwardRef<SVGSVGElement, SvgIconProps>(
  function WarningRound(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <circle cx={12} cy={12} fill="currentColor" r={12} />
        <path
          d="M12.136 6.672a.285.285 0 0 1 .114.114l5.053 9.293a.285.285 0 0 1-.25.421H6.947a.285.285 0 0 1-.25-.42l5.053-9.294a.285.285 0 0 1 .386-.114ZM12 14.107a.546.546 0 0 0-.535.556c0 .307.24.556.535.556a.546.546 0 0 0 .535-.556.546.546 0 0 0-.535-.556Zm.025-4.801c-.501 0-.908.35-.908.783l.629 2.71c.061.264.498.264.559 0l.629-2.71c0-.432-.407-.783-.909-.783Z"
          fill="#FFF"
        />
      </SvgIcon>
    )
  },
)

export default WarningRound
